import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MODES } from "@/components/shell/nav";

let cache = { favorites: [], recents: [], rail_order: [] };
const subs = new Set();
const emit = () => subs.forEach((f) => f({ ...cache }));

export const loadPrefs = () => api.get("/me/prefs").then((r) => { cache = { favorites: r.data.favorites || [], recents: r.data.recents || [], rail_order: r.data.rail_order || [] }; emit(); }).catch(() => {});
export const toggleFavorite = (fav) => api.post("/me/favorites/toggle", fav).then((r) => { cache = { ...cache, favorites: r.data.favorites }; emit(); return r.data.added; });
export const addRecent = (rec) => api.post("/me/recents", rec).then((r) => { cache = { ...cache, recents: r.data.recents }; emit(); }).catch(() => {});
export const setRailOrder = (order) => { cache = { ...cache, rail_order: order }; emit(); return api.put("/me/rail-order", { order }).catch(() => {}); };
export const resetRailOrder = () => setRailOrder([]);

export function usePrefs() {
  const [p, setP] = useState(cache);
  useEffect(() => { subs.add(setP); if (!cache.loaded) { cache.loaded = true; loadPrefs(); } return () => subs.delete(setP); }, []);
  return p;
}

export function pageLabel(pathname) {
  for (const m of MODES) for (const s of m.sections) for (const n of s.items) if (n.end ? pathname === n.to : pathname === n.to || pathname.startsWith(n.to + "/")) return s.label ? `${s.label} · ${n.label}` : n.label;
  return pathname.split("/").filter(Boolean).map((x) => x.replace(/-/g, " ")).join(" · ") || "Home";
}
